import React, { Component } from 'react';

import "./Readmore-ArticleItem.scss"

class ArticleItem extends Component {
    constructor() {
        super();
        this.state = {

        }
    }
    render() {
        const image = {
            backgroundImage: "url(" + this.props.item.image + ")"
        }
        return (
            <li>
                <div className="box">
                    <a href={this.props.item.link} title="" target="_blank">
                        <div style={image} className="image"></div>
                        <div className="desc">
                            {this.props.item.headline}
                        </div>
                    </a>
                </div>
            </li>
        );
    }
}

export default ArticleItem;



// WEBPACK FOOTER //
// ./src/components/Readmore/components/Readmore-ArticleItem/Readmore-ArticleItem.js